/* Approved mobile editorial layout. Only homepage roots are enhanced. */
const mobile = matchMedia('(max-width:700px)');
const roots = new Map();
function initialize(root) {
 if (roots.has(root)) return;
 const cleanup = [], rails = [], folds = [];
 const fold = (container, selector) => {
  const heading = container?.querySelector(selector);
  if (!heading) return;
  const details = document.createElement('details');
  details.className = 'fp4-flow-fold'; details.open = !mobile.matches;
  const summary = document.createElement('summary'); summary.textContent = heading.textContent;
  const content = document.createElement('div'); content.className = 'fp4-flow-fold-content';
  const original = [...container.childNodes];
  details.append(summary, content);
  const setMobile = enabled => {
   if (enabled) {
    original.forEach(node => { if (node !== heading) content.append(node); });
    heading.classList.add('fp4-flow-desktop-heading'); container.append(details); details.open = false;
   } else {
    original.forEach(node => container.append(node)); details.remove(); heading.classList.remove('fp4-flow-desktop-heading');
   }
  };
  folds.push(setMobile);
  cleanup.push(() => { original.forEach(node => container.append(node)); details.remove(); heading.classList.remove('fp4-flow-desktop-heading'); });
 };
 root.querySelectorAll('.fp5-shelf').forEach(shelf => {
  const rail = shelf.querySelector('.fp5-rail'), controls = shelf.querySelector('.fp5-rail-controls');
  if (!rail || !controls) return;
  const marker = document.createComment('Desktop shelf controls'); controls.before(marker);
  const footer = document.createElement('div'); footer.className = 'fp4-flow-shelf-footer';
  const progress = document.createElement('div'); progress.className = 'fp4-flow-progress';
  progress.setAttribute('role', 'progressbar'); progress.setAttribute('aria-label', 'Products browsed');
  progress.setAttribute('aria-valuemin', '0'); progress.setAttribute('aria-valuemax', '100');
  const indicator = document.createElement('span'); progress.append(indicator); footer.append(progress); shelf.append(footer);
  const update = () => {
   rail.classList.toggle('fp4-flow-four-grid', rail.children.length === 4);
   const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
   const visible = Math.min(1, rail.clientWidth / (rail.scrollWidth || 1));
   const position = maximum ? Math.min(1, Math.max(0, rail.scrollLeft / maximum)) : 0;
   indicator.style.width = `${visible * 100}%`; indicator.style.marginLeft = `${position * (1 - visible) * 100}%`;
   progress.setAttribute('aria-valuenow', String(Math.round((visible + position * (1 - visible)) * 100)));
   const count = rail.children.length, gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
   const step = (rail.firstElementChild?.getBoundingClientRect().width || 1) + gap;
   const start = Math.min(count, Math.round(rail.scrollLeft / step) + 1);
   const end = Math.min(count, start + Math.max(1, Math.round(rail.clientWidth / step)) - 1);
   progress.setAttribute('aria-valuetext', `Products ${start}–${end} of ${count}`);
   footer.hidden = maximum < 3;
   shelf.updateRail?.();
  };
  rail.addEventListener('scroll', update, {passive:true});
  const resize = new ResizeObserver(update); resize.observe(rail);
  const mutations = new MutationObserver(update); mutations.observe(rail, {childList:true});
  rails.push({rail, controls, marker, footer, update});
  cleanup.push(() => { resize.disconnect(); mutations.disconnect(); rail.removeEventListener('scroll', update); marker.after(controls); marker.remove(); footer.remove(); rail.classList.remove('fp4-flow-four-grid'); });
 });
 fold(root.querySelector('.fp5-designer-directory'), 'h3');
 root.querySelectorAll('.fp5-service>div').forEach(node => fold(node, 'h3'));
 const hero = root.querySelector('.fp5-hero');
 let previousWidth;
 const sizeHero = () => {
  const width = document.documentElement.clientWidth;
  if (!hero || width === previousWidth) return;
  previousWidth = width;
  hero.style.removeProperty('--fp4-hero-height');
  if (width <= 700) hero.style.setProperty('--fp4-hero-height', `${hero.getBoundingClientRect().height}px`);
 };
 if (hero) {
  sizeHero(); window.addEventListener('resize', sizeHero, {passive:true});
  cleanup.push(() => { window.removeEventListener('resize', sizeHero); hero.style.removeProperty('--fp4-hero-height'); });
 }
 const apply = () => {
  rails.forEach(state => {
   if (mobile.matches) state.footer.append(state.controls); else state.marker.after(state.controls);
   state.rail.scrollLeft = 0; state.update();
  });
  folds.forEach(setMobile => setMobile(mobile.matches));
 };
 mobile.addEventListener('change', apply); apply();
 cleanup.push(() => mobile.removeEventListener('change', apply));
 roots.set(root, () => { cleanup.reverse().forEach(fn => fn()); roots.delete(root); });
}
let footerCleanup;
function initializeFooter() {
 if (footerCleanup || !document.querySelector('[data-fp-v5]')) return;
 const footer = document.querySelector('.fp-footer'); if (!footer) return;
 const records = [];
 footer.querySelectorAll('.fp-footer__column').forEach(column => {
  const heading = column.querySelector('h2'), list = column.querySelector('ul');
  if (!heading || !list?.children.length) return;
  const details = document.createElement('details'); details.className = 'fp4-flow-fold';
  const summary = document.createElement('summary'); summary.textContent = heading.textContent;
  const content = document.createElement('div'); content.className = 'fp4-flow-fold-content';
  const marker = document.createComment('Original footer list'); list.before(marker);
  details.append(summary, content);
  records.push({details, heading, list, marker, column, content});
 });
 footer.classList.add('fp4-mobile-footer');
 const apply = () => records.forEach(r => {
  if (mobile.matches) {
   r.heading.classList.add('fp4-flow-desktop-heading'); r.content.append(r.list); r.column.append(r.details); r.details.open = false;
  } else {
   r.marker.after(r.list); r.details.remove(); r.heading.classList.remove('fp4-flow-desktop-heading');
  }
 });
 mobile.addEventListener('change', apply); apply();
 footerCleanup = () => {
  mobile.removeEventListener('change', apply);
  records.forEach(r => { r.marker.after(r.list); r.marker.remove(); r.details.remove(); r.heading.classList.remove('fp4-flow-desktop-heading'); });
  footer.classList.remove('fp4-mobile-footer'); footerCleanup = undefined;
 };
}
function boot(scope = document) {
 if (scope.matches?.('[data-fp-v5]')) initialize(scope);
 scope.querySelectorAll('[data-fp-v5]').forEach(initialize);
 initializeFooter();
}
boot();
document.addEventListener('shopify:section:load', event => boot(event.target));
document.addEventListener('shopify:section:unload', event => {
 [...roots].forEach(([root, dispose]) => { if (event.target.contains(root)) dispose(); });
 if (event.target.querySelector('.fp-footer')) footerCleanup?.();
});
